import { FETCH_DCM_CAMPAIGNS, SELECT_CAMPAIGN_ID } from "./constants";
import { SUCCESS, FAILURE, PENDING } from "../constants";

import { fetchCampaignsService } from "../../services/dcm/campaigns";
import { setAuthError } from "../app/global";

const beginFetchDcmCampaigns = searchString => ({
  type: FETCH_DCM_CAMPAIGNS,
  status: PENDING,
  searchString
});

const successDcmCampaigns = campaigns => ({
  type: FETCH_DCM_CAMPAIGNS,
  status: SUCCESS,
  data: campaigns
});

const failureDcmCampaigns = err => ({
  type: FETCH_DCM_CAMPAIGNS,
  status: FAILURE,
  err
});

export const fetchDcmCampaigns = (searchString) => {
  return async dispatch => {
    dispatch(beginFetchDcmCampaigns());

    let response;

    try {
      response = await fetchCampaignsService(searchString);

      dispatch(successDcmCampaigns(response));
    } catch (e) {
      if (e.message === "UNAUTHORIZED") {
        dispatch(setAuthError());
        return;
      }

      console.log(e);
      dispatch(failureDcmCampaigns(e));
    }
  };
};

export const selectCampaignId = id => ({
  type: SELECT_CAMPAIGN_ID,
  id
});
